<template>
  <div style="position: relative;">
    <input
      v-if="isMobileSafari"
      class="input-date-mobile"
      ref="inputDate"
      type="date"
      :value="currentValue"
      :disabled="disabled"
      @blur="onChangeDate"
    >
    <input
      v-else
      class="input-date-mobile"
      ref="inputDate"
      type="date"
      :value="currentValue"
      :disabled="disabled"
      @input="onChangeDate"
    >
  </div>
</template>

<script>
import dateFns from 'date-fns';

export default {
  name: 'InputDateMobile',
  props: {
    value: {},
    disabled: {
      type: Boolean
    },
    minimumDate: {
      type: [Date, String],
      default: null
    },
    maximumDate: {
      type: [Date, String],
      default: null
    },
    minimumDateWarningMessage: {
      type: String,
      default: '이전 날짜는 선택할 수 없습니다.'
    },
    maximumDateWarningMessage: {
      type: String,
      default: '이후 날짜는 선택할 수 없습니다.'
    },
    isUseMaximumDateFilter: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue === null) {
          return (this.currentValue = null);
        }
        this.currentValue = dateFns.format(newValue, 'YYYY-MM-DD');
        if (this.$refs['inputDate']) {
          this.$refs['inputDate'].value = dateFns.format(
            newValue,
            'YYYY-MM-DD'
          );
        }
      }
    }
  },
  data() {
    return {
      currentValue: null,
      isMobileSafari: false
    };
  },
  mounted() {
    this.isMobileSafari = this.isMbSafari();
  },
  methods: {
    onChangeDate(event) {
      let newValue = event.target.value;
      if (
        this.minimumDate &&
        dateFns.isAfter(new Date(this.minimumDate), new Date(newValue))
      ) {
        if (this.isMobileSafari) {
          this.$alert(this.minimumDateWarningMessage);
        } else {
          this.$message.warning(this.minimumDateWarningMessage);
        }
        return (event.target.value = null);
      }

      if (this.isUseMaximumDateFilter) {
        if (
          this.maximumDate &&
          dateFns.isBefore(new Date(this.maximumDate), new Date(newValue))
        ) {
          if (this.isMobileSafari) {
            this.$alert(this.maximumDateWarningMessage);
          } else {
            this.$message.warning(this.maximumDateWarningMessage);
          }
          return (event.target.value = null);
        }
      }

      this.$emit('input', newValue);
      if (this.isMobileSafari) {
        this.$emit('blur', newValue);
      } else {
        this.$emit('change', newValue);
      }
    },
    isMbSafari() {
      if (/android|iphone|ipad|ipod/i.test(navigator.userAgent)) {
        if (/chrome/i.test(navigator.userAgent)) {
          return false;
        } else if (/safari/i.test(navigator.userAgent)) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
.input-date-mobile {
  margin: 0;
  width: 100%;
  -webkit-appearance: none;
  height: 50px;
  line-height: 15px;
  font-size: 15px;
  letter-spacing: -0.8px;
  color: #4a4a4a;
  font-weight: 400;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #d3d3d3;
  padding-left: 15px;
  box-sizing: border-box;
}
</style>
